import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { RequestDto } from './dto/RequestDto';

/**
 * Статус Catch-up
 * https://master.api-profile.sandbox.d2c.r-one.io/docs/v1#/Catch%20Up/1b2fd31f9131c9a7a8694ccf35ef8850
 */
const getStateCatchUp = (queryParams: RequestDto): IRequest => ({
    uri: '/v1/catch-up/get-state-catch-up',
    method: 'GET',
    withAuth: true,
    withProvider: true,
    queryParams,
});

export type { ResponseDto } from './dto/ResponseDto';

export default getStateCatchUp;

